import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Sidebar from "../../sidebar/sidebar";
import MaterialTable from "@material-table/core";
import {
  useStyles,
  useStylesForMaterial,
  materialTableStyle,
  paginationStyle,
} from "../../reusable/styles";
import { useTranslation } from "react-i18next";
import Pagination from "../../reusable/pagination";
import { useDispatch, useSelector } from "react-redux";
import { optionsGeneral } from "../../reusable/optionsForTables";
import LoadingIndicator from "../../reusable/loadingIndicator";
import keycloak from "../../keycloak";
import { ROLES } from "../../consts";
import Style from "./whitelist.module.css";
import { WhitelistColumns } from "../../columns/whitelistColumns";
import {
  closeDuplicateWhitelistVehicleModal,
  getAllWhitelistForParkingZone,
  removeVehicleFromParkingZoneWhitelist,
} from "../../actions/whitelist";
import { getPaprkingZone } from "../../actions/parkingZone";
import { useState } from "react";
import AddVehicleToWhitelistModal from "./addVehicleToWhitelistModal";
import ErrorModal from "../../common/modal/errorModal";
import ConfirmationModal from "../../common/modal/confirmationModal";
import MagnifyingGlass from "../../common/assets/magnifying-glass.svg";
import {useAuth} from "react-oidc-context";

export default function Whitelist(props) {
  const auth = useAuth();
  const { t } = useTranslation();
  const classes = useStyles();
  const classesMaterial = useStylesForMaterial();
  const dispatch = useDispatch();
  const { whitelist, duplicateWhitelistVehicle } = useSelector(
    (state) => state.whitelist
  );
  const { parkingZone } = useSelector((state) => state.parkingZone);
  const { isLoading } = useSelector((state) => state.loader);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setHeight(window.innerHeight);
  };

  const [addVehicleToWhitelistModalOpen, setAddVehicleToWhitelistModalOpen] =
    useState(false);

  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);

  const [whitelistVehicleForDeleteId, setWhitelistVehicleForDeleteId] =
    useState(null);

  const deleteVehicleFromParkingZoneWhitelist = (id) => {
    dispatch(
      removeVehicleFromParkingZoneWhitelist(id, () =>
        setDeleteConfirmationModalOpen(false)
      )
    );
  };

  const openDeleteConfirmationModal = (id) => {
    setDeleteConfirmationModalOpen(true);
    setWhitelistVehicleForDeleteId(id);
  };

  const closeModalDuplicatedWhitelistVehicle = () => {
    dispatch(closeDuplicateWhitelistVehicleModal());
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  useEffect(() => {
    const parkingZoneId = props?.match?.params?.id;
    dispatch(getAllWhitelistForParkingZone(parkingZoneId));
    dispatch(getPaprkingZone(parkingZoneId));
  }, [dispatch, props?.match?.params?.id]);

  function toolbar() {
    return (
      <div className={Style.toolbar}>
        <div className={Style.toolbar__titleAndInfo}>
          <div className={Style.toolbar__titleAndInfo__title}>
            {t("Whitelist.title")}
          </div>
          <div className={Style.pzInfo}>
            <div className={Style.pzInfo__label}>
              {t("Whitelist.parkingZoneNumber")}
            </div>
            <div className={Style.pzInfo__value}>
              {parkingZone?.parkingZoneNumber}
            </div>
          </div>
          <div className={Style.pzInfo}>
            <div className={Style.pzInfo__label}>
              {t("Whitelist.parkingZoneName")}
            </div>
            <div className={Style.pzInfo__value}>
              {parkingZone?.parkingZoneName}
            </div>
          </div>
        </div>

        {(keycloak.hasRealmRole(ROLES.SYSADMIN, auth) ||
          keycloak.hasRealmRole(ROLES.PARKING_ADMIN, auth) ||
          keycloak.hasRealmRole(ROLES.PARKING_MANAGER, auth)) && (
          <div
            className={Style.addVehicle}
            onClick={() => setAddVehicleToWhitelistModalOpen(true)}
          >
            {t("Whitelist.addVehicle")}
          </div>
        )}
      </div>
    );
  }
  function pagination(props) {
    return (
      <td style={paginationStyle}>
        <Pagination translate={t} {...props} classes={{ ...classesMaterial }} />
      </td>
    );
  }

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth={false} className={classes.container}>
          {isLoading && <LoadingIndicator />}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className="text-center">
                <div className="row content">
                  <div className="col-sm-12">
                    <div className={classes.paper}>
                      <MaterialTable
                        icons={{
                          Filter: () => (
                            <img src={MagnifyingGlass} alt="search" />
                          ),
                        }}
                        searchPlaceholder="Test"
                        title={t("ParkingZones.ParkingZones")}
                        style={materialTableStyle}
                        data={whitelist}
                        columns={WhitelistColumns(
                          t,
                          openDeleteConfirmationModal
                        )}
                        options={optionsGeneral(height - 240, 44)}
                        components={{
                          Toolbar: (props) => toolbar(props),
                          Pagination: (props) => pagination(props),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </main>

      <AddVehicleToWhitelistModal
        open={addVehicleToWhitelistModalOpen}
        setModalOpen={setAddVehicleToWhitelistModalOpen}
        parkingZone={parkingZone}
      />

      <ErrorModal
        title={t("DulicateWhitelistWehicle.title")}
        errorMessage={t("DulicateWhitelistWehicle.message")}
        open={duplicateWhitelistVehicle}
        onClose={() => closeModalDuplicatedWhitelistVehicle()}
        width="400px"
      />

      <ConfirmationModal
        title={t("WhitelistDeleteConfirmationModal.title")}
        message={t("WhitelistDeleteConfirmationModal.message")}
        confirmationButtonText={t(
          "WhitelistDeleteConfirmationModal.buttonDelete"
        )}
        open={deleteConfirmationModalOpen}
        onClose={() => setDeleteConfirmationModalOpen(false)}
        confirmationAction={() =>
          deleteVehicleFromParkingZoneWhitelist(whitelistVehicleForDeleteId)
        }
        width="450px"
      />
    </div>
  );
}
